/**
 * Get the logo path
 * All logos are stored in /logos/ directory
 * 
 * @param logoName - The name of the logo file (e.g., 'life_logo.svg', 'mtn_logo.svg')
 * @returns The full path to the logo
 */
export function getMnoLogoPath(logoName: string): string {
  return `/logos/${logoName}`;
}

/**
 * Get the Life logo path for the current MNO
 */
export function getLifeLogoPath(): string {
  return getMnoLogoPath('life_logo.svg');
}

/**
 * Get the MNO logo path for the current MNO
 */
export function getMnoOperatorLogoPath(): string {
  return getMnoLogoPath('mtn_logo.svg');
}

/**
 * Get the Life spinner logo path for the current MNO
 */
export function getLifeSpinnerPath(): string {
  return getMnoLogoPath('life_spinner.svg');
}

